<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="about" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content">
      <h1>About GB Wave</h1>
      <p>
        <router-link to="/">GB Wave</router-link>
        is an independent website focused on providing information, guides, and updates about GB WhatsApp. Our goal is to help users understand GB WhatsApp features, installation steps, update methods, and common issues through clear and practical content.
      </p>
      <p>
        We publish detailed guides covering GB WhatsApp versions, privacy features, customization options, backup methods, troubleshooting solutions, and other helpful Android app information.
      </p>
      <p>
        GB Wave is not the official website of WhatsApp or Meta. We are an independent information platform and are not affiliated with WhatsApp LLC, Meta Platforms, Inc., or any official WhatsApp service.
      </p>
      <p>
        Our content is created to help users better understand third-party applications and make informed decisions before using them.
      </p>
      <p>
        If you have questions, suggestions, or feedback about our website, please contact our team.
      </p>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';

export default {
  name: 'AboutPage',
  components: { HeadNav, SeoBreadcrumb },
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'About', current: true },
      ],
    };
  },
};
</script>
